import { combineReducers } from 'redux';
import * as types from './constants';

const initialState = {
    list: {
        table: {
            data: [],
            links: {},
            meta: {}
        },
        filter: {}
    },
};

export default combineReducers({
    list(state = initialState.list, action) {
        switch (action.type) {
            default:
                return state;
        }
    },
});